import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ù",
  "use": "icon-Ù-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ù\">\n<path d=\"M49.134 28.024H31.758V10.648C31.758 9.688 30.99 8.92 30.03 8.92C29.022 8.92 28.254 9.688 28.254 10.648V28.024H10.878C9.918 28.024 9.15 28.792 9.15 29.752C9.15 30.76 9.918 31.528 10.878 31.528H28.254V48.904C28.254 49.912 29.022 50.68 30.03 50.68C30.99 50.68 31.758 49.912 31.758 48.904V31.528H49.134C50.094 31.528 50.862 30.76 50.862 29.752C50.862 28.792 50.094 28.024 49.134 28.024Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol